import { Typography, useTheme } from "@mui/material";
import React from "react";

function WTypography(props) {
  const theme = useTheme();

  return (
    <Typography
      sx={{
        color: theme.palette.appBar.color,
      }}
      {...props}
    >
      {/* {children} */}
    </Typography>
  );
}

export default WTypography;
